module.exports = __webpack_public_path__ + "images/4f95f598862b0a63cd6e1b921e7f65e7.svg";